<template>
  <div class="htList">
    <ld-statusbar bg-white />

    <div class="ht-list-header-filter">
      <div class="ht-list-header">
        <nav
          class="back-wrapper"
          @click="back"
        >
          <van-icon
            name="arrow-left"
            size="24px"
          />
        </nav>

        <div class="date-time">
          <div
            style="width:100%;"
            @click="pageCtrl.isChangeVoyage && $refs.city.toggle()"
          >
            <span
              class="main-color"
              style="padding-left: 0;"
            >{{ model._city }}</span>
          </div>
        </div>

        <div class="citysug date-time">
          <div
            class="date-time-line"
            @click="showDate"
          >
            <div v-if="this.$route.query.i == 1 ? true : false">
              <div class="checkinout">
                <span>{{ $t('live','住') }}</span>
                <span
                  class="main-color"
                  v-if="new Date(this.model.checkInDate) <= new Date()"
                >{{ max }}</span>
                <span
                  class="main-color"
                  v-else
                >{{ model.checkInDate && model.checkInDate.substring(5, model.checkInDate.length) }}</span>
              </div>
              <div class="checkinout">
                <span>{{ $t('leave','离') }}</span>
                <span
                  class="main-color"
                  v-if="new Date(this.model.checkInDate) <= new Date()"
                >{{ min }}</span>
                <span
                  class="main-color"
                  v-else
                >{{ model.checkOutDate && model.checkOutDate.substring(5, model.checkOutDate.length) }}</span>
              </div>
            </div>
            <div v-else>
              <div class="checkinout">
                <span>{{ $t('live','住') }}</span>
                <span class="main-color">{{ model.checkInDate && model.checkInDate.substring(5, model.checkInDate.length) }}</span>
              </div>
              <div class="checkinout">
                <span>{{ $t('leave','离') }}</span>
                <span class="main-color">{{ model.checkOutDate && model.checkOutDate.substring(5, model.checkOutDate.length) }}</span>
              </div>
            </div>
          </div>
          <div
            class="sug"
            @click="$router.push('/ht/htQuery/htSearch')"
          >
            <ld-icon type="iconsousuo" />
            <span>{{ model._keywords || '关键词/位置/品牌/酒店名' }}</span>
          </div>
        </div>

        <div
          class="icon-map-box"
          @click="changeHotelListModel"
        >
          <template v-if="hotelListMode === 1">
            <ld-icon type="iconditu1 icon-map" />
            <p class="font10">
              {{ $t('H009','地图') }}
            </p>
          </template>
          <template v-if="hotelListMode === 2">
            <ld-icon type="iconliebiao icon-map" />
            <p class="font10">
              列表
            </p>
          </template>
        </div>
      </div>

      <div class="Grid">
        <a
          v-if="model._international == 0 && interfaceOpenList.length <= 1"
          class="other-dropdown-btn"
          @click="(model.onlySign == '0' ? model.onlySign = '1' : model.onlySign = '0') && mescroll.triggerDownScroll()"
        >
          <span :class="{ 'main-color': model.onlySign != '0'}">{{ $t('A021','协议酒店') }}</span>
        </a>
        <div class="Grid-cell">
          <van-dropdown-menu class="h40 deep-dropdown-item">
            <van-dropdown-item
              v-model="platIndex"
              v-if="model._international == 0 && interfaceOpenList.length > 1"
              :options="van_dropdown_platMenu.option"
              @change="hanldeChangePlat"
            />
            <van-dropdown-item
              v-model="model.sort"
              :options="model._international == 0 ? van_dropdown_menu.option : van_dropdown_menu_int.option"
              @change="mescroll.triggerDownScroll()"
              :title-class="(model.sort) ? 'main-color' : ''"
            />
            <van-dropdown-item
              :title="$t('H014','星级价格')"
              ref="item"
              class="filter-panel"
              :title-class="(model._starRate && model._starRate.length || model._priceRange && model._priceRange.length) ? 'main-color' : ''"
            >
              <div class="drop-box">
                <h3>
                  {{ starItems.typeName }}
                  <span>(可多选)</span>
                </h3>
                <ul class="van-clearfix">
                  <li
                    class="item-3"
                    v-for="(item, index) in starItems.staticDataBeanList"
                    :key="index"
                    @click="checkedStarItem(item)"
                  >
                    <a :class="{ 'active main-color': item.checked }">{{ item.conditionName }}</a>
                  </li>
                </ul>
                <h3>
                  {{ priceItems.typeName }}
                </h3>
                <ul class="van-clearfix">
                  <li
                    class="item-3"
                    v-for="(item,index1) in priceItems.staticDataBeanList"
                    :key="index1"
                    @click="checkedPriceItem(item)"
                  >
                    <a :class="{ 'active main-color': item.checked }">{{ item.conditionName }}</a>
                  </li>
                </ul>
              </div>
              <div class="filter-panel__reset">
                <a
                  class="reset"
                  @click="resetStarItems()"
                >{{ $t('Reset','重置') }}</a>
                <a
                  class="selection bg-main"
                  @click="selectType()"
                >{{ $t('Display','显示结果') }}</a>
              </div>
            </van-dropdown-item>

            <van-dropdown-item
              v-if="model._international == 0"
              :title="$t('C121','筛选')"
              ref="screen"
              class="filter-panel"
              :title-class="(this.model.brandIds || this.model.zcfs || this.model.roomBedType || this.model.propertyIds || this.model.themes) ? 'main-color' : ''"
            >
              <van-tree-select
                :items="van_tree_select_data.items"
                :active-id.sync="van_tree_select_data.activeIds"
                :main-active-index.sync="van_tree_select_data.mainActiveIndex"
              >
                <div slot="content">
                  <div
                    v-for="(item, index2) in van_tree_select_data.items"
                    :key="index2"
                  >
                    <div
                      class="drop-box"
                      v-if="van_tree_select_data.mainActiveIndex === index2"
                    >
                      <div v-if="item.text === '品牌'">
                        <div
                          v-for="(Condition, index3) in ConditionTypeEnum"
                          :key="index3"
                        >
                          <h3>{{ Condition.label }}</h3>
                          <ul class="van-clearfix">
                            <template v-for="(item_, index4) in item.children">
                              <li
                                v-if="Condition.id === item_.conditionType"
                                class="item-3"
                                :key="index4"
                                @click="item_.checked ? item_.checked = false : item_.checked = true"
                              >
                                <a :class="{ 'active main-color': item_.checked }">{{ item_.text }}</a>
                              </li>
                            </template>
                          </ul>
                        </div>
                      </div>
                      <div v-else>
                        <ul class="van-clearfix">
                          <li
                            class="item-3"
                            v-for="(item_, index3) in item.children"
                            :key="index3"
                            @click="item_.checked ? item_.checked = false : item_.checked = true"
                          >
                            <a :class="{ 'active main-color': item_.checked }">{{ item_.text }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </van-tree-select>
              <div class="filter-panel__reset">
                <a
                  class="reset"
                  @click="resetItems()"
                >{{ $t('Reset','重置') }}</a>
                <a
                  class="selection bg-main"
                  @click="selectType()"
                >{{ $t('Display','显示结果') }}</a>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
      <div
        class="Grid"
        style="justify-content: space-evenly;"
        v-if="false"
      >
        <van-dropdown-menu
          active-color="#1989fa"
          class="h40 deep-dropdown-item"
          style="position:relative;left: -142px;"
        >
          <van-dropdown-item
            @change="changeva(value1)"
            v-model="value1"
            :options="option1"
          />
        </van-dropdown-menu>
      </div>
    </div>
    <!-- 酒店列表 -->
    <transition name="van-fade">
      <div
        :class="(loginConfig &&loginConfig.pageName &&loginConfig.pageName.indexOf('柒个贰') > -1) ? 'htlistBTLH':'htlist' "
        v-show="hotelListMode === 1"
      >
        <div
          v-if="model._street && model._international == 0"
          class="current"
        >
          当前位置：{{ model._street }}附近
        </div>

        <mescroll-vue
          ref="mescroll"
          :up="mescrollUp"
          @init="mescrollInit"
        >
          <div class="container">
            <ht-contact-item
              :c="[0, 1]"
              :data="''"
              :items="van_list.list"
              :search-type="model.searchType"
            />
            <div id="hotel-empty" />

            <ht-contact-item
              v-if="van_list.nearList.length"
              title="附近酒店"
              :c="[0, 1]"
              :data="''"
              :items="van_list.nearList"
              :search-type="3"
            />
          </div>
        </mescroll-vue>
      </div>
    </transition>
    <!-- 专属客服 -->
    <ld-call-service
      style=""
      name="van-fade"
      v-if="
        loginConfig &&
          loginConfig.pageName &&
          loginConfig.pageName.indexOf('柒个贰') > -1
      "
      from="10910"
    />
    <transition name="van-fade">
      <div
        class="htlist-map"
        v-show="hotelListMode === 2"
      >
        <div
          id="hotelMap"
          style="height: calc(100vh - 84px);"
        />
        <div class="top-toast">
          <template v-if="van_list.total > mapMaxShowNum">
            共{{ van_list.total }}家酒店 ，展示前{{ mapMaxShowNum }}家
          </template>
          <template v-else>
            共{{ van_list.total }}家酒店
          </template>
        </div>


        <van-tag
          class="safe-bottom"
          type="primary"
          round
          size="large"
          @click="changeHotelListModel"
          style="position: fixed;bottom: 160px;right: 10px;"
        >
          回列表
        </van-tag>

        <ht-contact-item
          class="map-list safe-bottom"
          :c="[0, 1]"
          :data="''"
          :items="van_list.mapList"
          :search-type="model.searchType"
        />
      </div>
    </transition>
    <ld-calendar
      ref="date"
      type="range"
      @selected="getDate"
    />

    <!-- 选择城市控件 -->
    <city
      ref="city"
      @selected="arrdepChange"
      :tab-index="model._international"
      :city-type="1"
    />
  </div>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Popover,
  Tag
} from 'vant'
import { formatDate, getDiffDays } from 'Utils/dateUtil'
import { mapState,mapGetters } from 'vuex'
import ldStatusbar from 'Common/ldStatusbar'
import map_location from '../htMap/img/map-location.png'
import LD_AMap from '@/business/views/Car/carQuery/AMap'
import { queryVipParameter } from '@/business/utils/publicApi'
import ldCallService from 'Components/ldCallService'
import defaultMixin from '../../../../mixins/default'

const ConditionTypeEnum = [
  { id: 1, label: '经济' },
  { id: 2, label: '舒适' },
  { id: 3, label: '高档' },
  { id: 4, label: '豪华' },
]

export default {
  name: 'HtList',
  mixins:[defaultMixin],
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Popover.name]: Popover,
    [Tag.name]: Tag,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldCalendar: () => import('Common/ldCalendar'),
    City: () => import('Common/city'),
    HtContactItem: () => import('Views/Ht/htQuery/htContactItem/index.vue'),
    ldStatusbar,
    ldCallService,
  },
  data () {
    return {
      value1: 0,
      value2: 'a',
      option1: [
        { text: '快速筛选', value: 0 },
        { text: '符合差标', value: 1 },
        { text: '目的地附近', value: 2 },
      ],

      max:'',
      min:'',
      hotelListMode: 1, // 展示酒店模式。 1列表形式，2地图形式
      mapMaxShowNum: 20,
      hotelMapInstance: null,
      htListScrollTop: 0,
      mescroll: null, // mescroll实例对象
      platIndex: 0,
      interfaceOpenList: [],
      htlistStyle:'',
      van_dropdown_platMenu: {
        option: []
      },
      van_dropdown_menu: {
        option: [
          { text: '推荐排序', value: 12 },
          { text: '低价优先', value: 31 },
          { text: '高价优先', value: 32 }
        ]
      },
      van_dropdown_menu_int: {
        option: [
          { text: '推荐排序', value: 12 },
          { text: '好评优先', value: 5 },
        ]
      },
      van_tree_select_data: {
        items: [],
        activeIds: [],
        mainActiveIndex: 0
      },
      van_list: {
        list: [],
        nearList: [],
        mapList: [],
        total: 0,
        loading: false,
        finished: false
      },
      van_pull_refresh: {
        isLoading: false
      },
      van_skeleton: {
        loading: false
      },
      mescrollUp: {
        auto: false,
        callback: this.upCallback,
        // -- 我也是有底线的 --
        htmlNodata: '<p class="upwarp-nodata">-- 我也是有底线的 --</p>',
        toTop: {
          src: null,//require('Assets/images/icon_back.png'), //图片路径,默认null,支持网络图
          offset: 1000 //列表滚动1000px才显示回到顶部按钮
        },
        customHtmlNodata: false,
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          warpId: 'hotel-empty', //父布局的id (1.3.5版本支持传入dom元素)
          // icon: "~/", //图标,默认null,支持网络图
          tip: '-- 没有查询到数据 --' //提示
        }
      },
      starItems: {
        staticDataBeanList: []
      },
      /**
       * 价格区间
       */
      priceItems: {
        typeName: '价格',
        staticDataBeanList: [{
          checked: false,
          conditionName: '¥150以下',
          id: '0-150'
        }, {
          checked: false,
          conditionName: '¥150-¥300',
          id: '150-300'
        }, {
          checked: false,
          conditionName: '¥300-¥500',
          id: '300-500'
        }, {
          checked: false,
          conditionName: '¥500-¥800',
          id: '500-800'
        }, {
          checked: false,
          conditionName: '¥800以上',
          id: '800-99999'
        }]
      },
      ConditionTypeEnum,
    }
  },
  beforeRouteEnter (to, from, next) {
    // 从搜索条件页面 回到 列表 且 带了参数回来  刷新下列表
    next(vm => {
      vm.$nextTick(() => {
        if (vm.mescroll) {
          vm.mescroll.scrollTo(vm.htListScrollTop, 0)

          if (from.name === 'htSearch' && vm.model._keywords) {
            vm.mescroll.triggerDownScroll()
          }
        }
      })
    })
  },
  beforeRouteLeave (to, from, next) {
    this.htListScrollTop = this.mescroll.getScrollTop()
    next()
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
      model: (state) => state.ht.htSearchInfo,
      interfacePlat: state => state.ht.interfacePlat,
      /**
		 * 页面差旅标准对象
		 */
      pageCtrl: state => state.ht.pageCtrl,
      travelerList: (state) => state.ht.travelerList,
    }),
    ...mapGetters({

      loginConfig:'loginConfig'

    })
  },
  created () {
    this.loadData()
    if(this.$route.query.i ==1){
      this.max = formatDate(new Date()).monDay2
      this.min = formatDate(new Date(),1).monDay2
      console.log(formatDate(new Date()))
    }
    console.log(new Date(this.model.checkInDate) <= new Date() )
    console.log(this.model)
  },
  methods: {
    // 快速筛选
    changeva(val){
    },
    loadData () {
      this.model.sort = 12
      this.model.onlySign = 0
      this.model._starRate = []
      this.model._priceRange = []
      this.model.starRate = ''
      this.model.priceRange = ''
      this.model.brandIds = ''
      this.model.zcfs = ''
      this.model.roomBedType = ''
      this.model.propertyIds = ''
      this.model.themes = ''

      /**
        * 获取平台列表
        * 默认选中第一个
        */
      this.$api['htQuery/getOpenPlat']().then(async res => {
        this.interfaceOpenList = res.data || []
        this.interfaceOpenList.forEach((interfaceOpen, i) => {
          this.van_dropdown_platMenu.option.push({
            text: interfaceOpen.interfacePlatName,
            value: i
          })
        })

        this.van_dropdown_platMenu.option.push({
          text: '协议酒店',
          value: 'onlySign'
        })

        const { value1 } = await queryVipParameter('1518')
        if (value1) {
          let qtxy_plat = {
            text: '线上协议',
            value: 'priceSourceType2'
          }
          this.interfaceOpenList.push(qtxy_plat)
          this.van_dropdown_platMenu.option.push(qtxy_plat)
        }

        if (this.interfaceOpenList.length > 0) {
          this.hanldeChangePlat(0)
        } else {
          this.$store.commit('ht/interfacePlat', {})
          this.findJdStaticData()
          this.mescroll.triggerDownScroll()
        }
      })
    },
    /**
     * 获取星级、品牌数据
     */
    findJdStaticData () {
      this.$api['htQuery/findJdStaticData']({
        interfacePlatId: this.interfacePlat.interfacePlatId,
        by5: this.interfacePlat.by5
      }).then(res => {
        /**
         * 星级数据放到"星级价格"操作内
         */
        res.data[0].staticDataBeanList.forEach(element => {
          element.checked = false
        })
        this.starItems = res.data[0]
        /**
         * 品牌数据是要放到"筛选"操作内
         * 品牌数据需要转换成van_tree_select组件可用的数据格式
         * 属性 conditionType - 1经济 2舒适 3高档 4豪华
         */
        let array_ = []
        let array = []
        let data_ = [res.data[1], res.data[2], res.data[3]]
        data_.forEach((element, i) => {
          if (element.staticDataBeanList && element.staticDataBeanList.length > 0) {
            array_.push({
              text: element.typeName,
              children: (() => {
                let _array = []
                element.staticDataBeanList.forEach(element_ => {
                  let checkedIds = this.model.brandIds
                  if (i == 1) {
                    checkedIds = this.model.roomBedType
                  } else if (i == 2) {
                    checkedIds = this.model.zcfs
                  }

                  _array.push({
                    conditionType: element_.conditionType,
                    text: element_.conditionName,
                    id: element_.id,
                    /**
                   * 判断model中的品牌(brandIds)节点是否存在该值
                   * 若存在，checked:true选中该值
                   */
                    checked: checkedIds.split(',').includes(element_.id) ? true : false
                  })
                })
                return _array
              })()
            })
          }
        })

        /**
         * 获取筛选下的设施与主题数据  暂时先注释掉
         * 同样的数据也需要转换成van_tree_select组件可用的数据格式
         */
        this.$api['htQuery/findJdStaticByCityIdData']({
          cityId: this.model.cityId
        }).then(res_ => {

          /*	res_.data && res_.data.forEach(element => {
						array.push({
							text: element.typeName,
							children: (() => {
								let _array = []
								element.staticDataByCityBeanList.forEach(element_ => {
									_array.push({
										text: element_.conditionName,
										id: element_.id,
										/!**
                     * 判断model中的设施、主题节点是否存在该值
                     * 若存在，checked:true选中该值
                     *!/
										checked: (() => {
											let isType = false
											if (element.typeName == '设施') {
												isType = this.model.propertyIds.split(',').includes(element_.id) ? true : false
											}
											if (element.typeName == '主题') {
												isType = this.model.themes.split(',').includes(element_.id) ? true : false
											}
											return isType
										})()
									})
								})
								return _array
							})()
						})
					})*/
          /**
					 * 原本通过将2个接口请求回来的数据进行格式处理并合并后，
					 * 选中的id集合与原来的数据进行遍历区分进行归类，
					 * 因为接口入参中的设施、品牌、主题入参是分开的，多个各自以逗号的方式隔开传入。
					 * 但是品牌数据的id和主题数据的id存在相同的情况，所以van_tree_select组件的右侧采用自定义内容的方式
					 * 选中的选项通过在原数据模型上绑定checked:true的方式，
					 * 在执行查询的时候，通过遍历van_tree_select_data.items中各分类子项是否存在checked:true的，
					 * 各自取出id（多个逗号隔开）入参查询。
					 */
          this.van_tree_select_data.items = array_.concat(array)

        }).catch(() => { })
      }).catch(() => { })
    },
    /**
     * 切换平台资源
     * i为 onlySign 为页面写死的协议酒店
     */
    hanldeChangePlat (i) {
      if (i === 'onlySign') {
        this.model.onlySign = '1'
      } else {
        this.model.onlySign = '0'
      }

      if (i === 'priceSourceType2') {
        this.model.priceSourceType = '2'
        i = this.interfaceOpenList.findIndex(interf => interf.interfacePlatName === '千淘')
      } else {
        this.model.priceSourceType = undefined
      }

      this.$store.commit('ht/interfacePlat', this.interfaceOpenList[i] || {})

      // 国际暂时不传 singaZhid platZhid
      if (this.model._international == 1) {
        this.$store.commit('ht/interfacePlat', {})
      }

      this.findJdStaticData()
      this.mescroll.triggerDownScroll()
    },
    changeHotelListModel () {
      this.hotelListMode === 1 ?
        this.hotelListMode = 2 :
        this.hotelListMode = 1

      if (this.hotelListMode == 2 && !this.hotelMapInstance) {
        this.$nextTick(() => {
          this.loadHotelMap()
        })
      }
    },
    loadHotelMap () {
      this.hotelMapInstance = new LD_AMap({
        id: 'hotelMap',
        zoom: 14,
        GeoOffset: [18, 150],
        autoLocationSetCenter: false,
        mapMount: () => {
          this.genHotelMarker()
        },
        completed: () => {
        }
      })
    },
    async genHotelMarker () {
      this.hotelMapInstance.map.clearMap()  // 删除地图上所有的覆盖物
      let overlays = []
      this.van_list.mapList = []

      if (this.van_list.list.length) {
        // 如果是按经纬度查询的，需要把查询的时候的经纬度作为坐标点重点标出来
        if (this.model.searchType == 3) {
          // 生成中心点
          const { lng, lat } = await LD_AMap.convertFrom([this.model.lon, this.model.lat], 'baidu')

          this.hotelMapInstance.addMarker({
            content: `<img src="${map_location}" width="32">`,
            name: new Date().getTime(),
            position: [lng, lat],
            offset: [-16, -32], // 相对于基点的偏移位置
            zIndex: 999
          })
        }

        // 生成 价格列表的前${mapMaxShowNum}个 价格标记
        this.van_list.list.filter((val, i) => i < this.mapMaxShowNum).forEach(async (hotel, i) => {
          let price = `&yen;<font class="font16">${hotel.price}</font>起`

          if ((hotel.source == 1 || hotel.source == 2) && this.model._international == 0) {
            price = '<font class="font16">协议</font>'
          }

          let content = `
                <div class="van-popup van-popover van-popover--light htlist-map__price--marker" data-popper-placement="top">
                  <div class="van-popover__arrow" style="transform: translate(-50%, 200%);border-width: 13px;"></div>
                  <div class="van-popover__content">${price}</div>
                </div>
              `
          const { lng, lat } = await LD_AMap.convertFrom([hotel.baiduLon, hotel.baiduLat], 'baidu')

          let marker = this.hotelMapInstance.addMarker({
            content: content,
            zIndex: this.mapMaxShowNum - i,
            name: String(hotel.jdid),
            position: [lng, lat], // 基点位置
            offset: [-34, -38] // 相对于基点的偏移位置
          }).on('click', () => {
            this.van_list.mapList = [hotel]

            overlays.forEach(o => {
              o.dom.querySelector('.htlist-map__price--marker').classList.remove('active')
            })

            marker.dom.querySelector('.htlist-map__price--marker').classList.add('active')
          })

          overlays[i] = marker
        })

        setTimeout(() => {
          this.hotelMapInstance.map.setFitView(overlays, true, [60, 160, 60, 60])

          // 默认选第一个
          this.van_list.mapList = [this.van_list.list[0]]
          overlays[0].dom.querySelector('.htlist-map__price--marker').classList.add('active')
        }, 500)
      }
    },
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      // window.$$mescroll = mescroll
    },
    upCallback (page) {
      this.model.pageNum = page.num
      if (this.model._international == 0) {

        this.$api['htQuery/hotelList'](this.model).then(res => {
          // res = {'data':{'total':'169','pages':9,'pageNum':1,'count':20,'list':[{'jdid':'H626329','jdmc':'东莞凯利酒店','address':'元美路西侧','starRate':'4','category':'4','phone':'+86-769-22286888','baiduLat':23.015552,'baiduLon':113.750828,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H626329/hotel_9F93547AC1C4623950B2A55BC7D30C81CG.jpg','score':'5','price':318.0,'distance':'2.0','source':0,'facilitator':'2000010'},{'jdid':'M207767','jdmc':'百时快捷酒店(东莞南城西平地铁站店)','address':'宏伟路与西平三路交叉处','starRate':'2','category':'2','phone':'0769-28680303','baiduLat':22.996247190073,'baiduLon':113.75542939364,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M207767/hotel_7856FE9BD18694BF9346149848FDA462CG.jpg','score':'4','price':76.0,'distance':'1.7','source':0,'facilitator':'2000010'},{'jdid':'H275425','jdmc':'7天连锁酒店(东莞鸿福路地铁站店)','address':'元美东路2号（鸿福路地铁站B出口、汇一城对面）','starRate':'2','category':'2','phone':'0769-89209688','baiduLat':23.015672,'baiduLon':113.761279,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H275425/hotel_1358D16F9B15962EDC19BB19F8097FDECG.jpg','score':'4','price':121.0,'distance':'2.7','source':0,'facilitator':'2000010'},{'jdid':'M207772','jdmc':'锦江之星(东莞南城西平地铁站店)','address':'宏伟路与西平三路交叉处','starRate':'2','category':'2','phone':'+86-769-23097999-0','baiduLat':22.996323,'baiduLon':113.7554,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M207772/hotel_8093B16C0611917B8760B9B639F03825CG.jpg','score':'4','price':126.0,'distance':'1.7','source':0,'facilitator':'2000010'},{'jdid':'M6253277','jdmc':'凯里亚德酒店（东莞南城店）','address':'元美西路11号','starRate':'2','category':'2','phone':'0769-26996888','baiduLat':23.015470436665,'baiduLon':113.751519378322,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M6253277/hotel_229D2301E1A292DFFCE602E208E78CBECG.jpg','price':296.0,'distance':'2.0','source':0,'facilitator':'2000010'},{'jdid':'M7271603','jdmc':'知程酒店(东莞中世和发湾one店)','address':'中世和发大厦湾one公寓119号铺','starRate':'2','category':'2','phone':'+86-15338379505','baiduLat':22.986808,'baiduLon':113.732793,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M7271603/hotel_516E87858990E6C7DE582FB781FFEFDDCG.jpg','price':309.0,'distance':'1.7','source':0,'facilitator':'2000010'},{'jdid':'M5277209','jdmc':'知程公寓（东莞寰宇汇金店）','address':'隆溪路寰宇汇金凯建大厦1号楼23楼08室','starRate':'2','category':'2','phone':'+86-18002720823','baiduLat':22.989492,'baiduLon':113.736467,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M5277209/hotel_7E1E73BC9D69A0CCB07EC12E989C6CB4CG.jpg','price':320.0,'distance':'1.3','source':0,'facilitator':'2000010'},{'jdid':'M4016784','jdmc':'Lazy电竞酒店（东莞宏远店）','address':'南城街道宏远4-4号','starRate':'2','category':'2','phone':'15014884946','baiduLat':23.015568,'baiduLon':113.743275,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M4016784/hotel_1CC9196808D318FE1AE0B860DDAE8653CG.jpg','price':321.0,'distance':'1.7','source':0,'facilitator':'2000010'},{'jdid':'M4922110','jdmc':'东莞Dan328公寓(2号店)','address':'香槟公寓-A座(汇一城，国贸旁)','starRate':'2','category':'2','phone':'862126137886,4393782','baiduLat':23.014946,'baiduLon':113.76296,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M4922110/hotel_0359BAC5CDA8C402E5C19A79E3ECE2BDCG.jpg','price':335.0,'distance':'2.8','source':0,'facilitator':'2000010'},{'jdid':'H625897','jdmc':'东莞会展国际大酒店','address':'会展北路1号','starRate':'4','category':'4','phone':'0769-22889999','baiduLat':23.023092370407,'baiduLon':113.76578059765,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H625897/hotel_0A1B81CADB2EBEDF293F3AC2EB8BCBC9CG.jpg','price':421.0,'distance':'3.6','source':0,'facilitator':'2000010'},{'jdid':'H838486','jdmc':'东莞宏明旅馆','address':'金园路2号','starRate':'2','category':'2','phone':'+86-769-28056046','baiduLat':23.01471,'baiduLon':113.736688,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H838486/hotel_B0F6973F3B52B6AD6EFBCD6FF462A9DBCG.jpg','price':71.0,'distance':'1.6','source':0,'facilitator':'2000010'},{'jdid':'M8323014','jdmc':'东莞南城精选公寓','address':'南城街道胜和管理区大王新村6巷1号','starRate':'2','category':'2','phone':'13929203237','baiduLat':23.024156,'baiduLon':113.751638,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M8323014/hotel_4B979C9FC2EAA2F9FCB377B9191F0314CG.png','price':71.0,'distance':'2.9','source':0,'facilitator':'2000010'},{'jdid':'H626231','jdmc':'东莞顺发旅馆','address':'南城街道众利路30号','starRate':'2','category':'2','phone':'+86-13360467705','baiduLat':22.998586,'baiduLon':113.728736,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H626231/hotel_CAB88262DCF2A504E5DD5BA40EB1A483CG.png','price':71.0,'distance':'1.2','source':0,'facilitator':'2000010'},{'jdid':'M5675050','jdmc':'乐家公寓','address':'胜和路陈屋栏北五巷5号','starRate':'2','category':'2','phone':'18929130059','baiduLat':23.0238981104829,'baiduLon':113.752032609997,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M5675050/hotel_288D2A1F382605964FC78A108E2FD8F6CG.jpg','price':85.0,'distance':'2.8','source':0,'facilitator':'2000010'},{'jdid':'H625015','jdmc':'QQ公寓(东莞金园路店)','address':'金丰商业街街金园路13号','starRate':'2','category':'2','phone':'+86-13538306815','baiduLat':23.014858757324,'baiduLon':113.73730145561,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H625015/hotel_404FEBE42EBFE0D7E482778176BB54ADCG.jpg','price':71.0,'distance':'1.6','source':0,'facilitator':'2000010'},{'jdid':'H997276','jdmc':'东莞银泉连锁酒店(东莞店)','address':'英联路口篁村综合楼','starRate':'2','category':'2','phone':'+86-769-21686826','baiduLat':23.018296,'baiduLon':113.745388,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H997276/hotel_019429C3C74CD0BA9A5E373522F29AC3CG.jpg','price':71.0,'distance':'2.0','source':0,'facilitator':'2000010'},{'jdid':'H794207','jdmc':'东莞爱群住宿','address':'坝新路爱群商业街旁','starRate':'1','category':'1','phone':'+86-18929155828','baiduLat':23.014861566939,'baiduLon':113.71305946595,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/H794207/hotel_86D42E29C276BA89A071B8D3A971A5FBCG.jpg','price':71.0,'distance':'3.2','source':0,'facilitator':'2000010'},{'jdid':'M8345153','jdmc':'东莞万江爱心公寓','address':'简沙洲大道2号','starRate':'2','category':'2','phone':'18028995186','baiduLat':23.01435,'baiduLon':113.715725,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M8345153/hotel_363BFA9AF03232E191ACA035298E40ACCG.png','price':71.0,'distance':'2.9','source':0,'facilitator':'2000010'},{'jdid':'M1565407','jdmc':'东莞安心住宿南城店','address':'东莞南城区亨美红棉路二巷3号','starRate':'2','category':'2','phone':'0-13537153233','baiduLat':23.01928,'baiduLon':113.74932,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M1565407/hotel_F10B353CF1C50E6D5279BE868C1F411CCG.png','price':71.0,'distance':'2.3','source':0,'facilitator':'2000010'},{'jdid':'M1810529','jdmc':'东莞康顺公寓','address':'白马社区先锋路八栋117（快马物流斜对面）','starRate':'2','category':'2','phone':'0769-23381037','baiduLat':22.988625,'baiduLon':113.720956,'introEditor':'','img':'https://image.qiantaohotel.com/Hotels/M1810529/hotel_9105994A26E0465ECCECDA3F29F69BA9CG.jpg','price':71.0,'distance':'2.4','source':0,'facilitator':'2000010'}]},'errCode':'1','errMsg':'success','tips':'success','timestamp':'1627116598548','requuid':'8d013543ffe64cd4bfa8884bbbd0ab75','env':'prod'}
          let arr = res.data ? res.data.list ? res.data.list : [] : [] // 请求的列表数据
          if (page.num === 1) {
            this.van_list.list = []
            this.van_list.nearList = [] // 如果是第一页需手动置空列表
            this.van_list.total = res.data ? res.data.total : 0
            this.mescroll.scrollTo(0, 0)
          }

          if (this.van_list.nearList.length === 0) {
            if (page.num === 1) {
              this.van_list.list = arr
            } else {
              this.van_list.list = this.van_list.list.concat(arr) // 把请求到的数据添加到列表
            }

            if (page.num && this.hotelMapInstance) {
              this.genHotelMarker()
            }
          }

          this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
            this.mescroll.endSuccess(arr.length)
          })

          /**
           * 将数据列存储
           */
          this.model._listData = this.van_list.list

          /**
           * 提示酒店总数
           */
          if (page.num === 1 && this.van_list.total > 0 && this.hotelListMode == 1 && this.van_list.list.length > 0) {
            this.$toast({
              message: `${this.van_list.total}家酒店`,
              position: 'bottom',
            })
          }

          if (arr.length < res.data.count) this.mescrollUp.customHtmlNodata = true

          // 如果只有一个酒店  那么 获取一下附近酒店
          if (this.mescrollUp.customHtmlNodata && this.van_list.list.length === 1) {
            this.getNearHotelList(page)
          }


        }).catch(() => {
          this.mescroll.endErr() // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        })

      } else if (this.model._international == 1) {
        this.$api['htQueryInt/hotelList']({
          'tripType': this.$store.state.app.tripType, // 差旅类型,1是因公,2是因私 因公时必填 ,
          'singaZhid': this.model.singaZhid,
          'platZhid': this.model.platZhid,
          'cityId': this.model.cityId, // 城市编码 ,
          'checkInDate': this.model._checkInDate.data, // 入住日期 ,
          'checkOutDate': this.model._checkOutDate.date, // 离店日期 ,
          'queryText': this.model.keywords, // 关键字 ,
          'facilities': this.model.propertyIds, // 设施ID,多个半角逗号分隔 ,
          'facilitieNames': this.model.facilitieNames, // 设施ID,多个半角逗号分隔 ,
          'themeIds': this.model.themes, // 主题ID,多个半角逗号分隔 ,
          'starRate': this.model.starRate, // 推荐星级 不限就不传；二星级以下,传2；三星传3；以此类推,多个以半角逗号隔开 ,
          'brandId': this.model.brandIds, // 本地热门品牌编码,多个半角逗号分隔 ,
          'priceRange': this.model.priceRange, // 价格范围，格式为：最低价-最高价，价格起止只能为正整数 ,
          'districtId': this.model.district, // 行政区编码 ,
          'districtName': this.model.districtName, // 行政区名称 ,
          'businessZoneId': this.model.businessZone, // 商圈编码 ,
          'businessZoneName': this.model.businessZoneName, // 商圈名称 ,
          'longitude': this.model.lat, // 经度 ,
          'latitude': this.model.lon, // 维度 ,
          'radius': 3, // 离指定经纬度距离（单位：公里）。默认3公里 ,
          'sort': this.model.sort, // 排序类型 0 默认排序 1星级降序 2价格升序 3价格降序 4距离升序 5评分降序 6星级升序 ,
          'payType': '', // 产品类型 1现付 2预付 0或空不限 ,
          'pageNum': 1, // 当前页数，不能小于1 ,
          'count': 20 // 每页显示条数，不能小于10
        }).then(res => {
          let arr = res.data ? res.data.list : [] // 请求的列表数据
          if (arr.length < res.data.count) this.mescrollUp.customHtmlNodata = true
          if (page.num === 1) this.van_list.list = [] // 如果是第一页需手动置空列表
          this.van_list.list = this.van_list.list.concat(arr) // 把请求到的数据添加到列表
          this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
            this.mescroll.endSuccess(arr.length)
          })
          /**
					 * 将数据列存储
					 */
          this.model._listData = this.van_list.list
        }).catch(() => {
          this.mescroll.endErr() // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        })
      }

      /**
       * 通过model对象中的经纬度来控制 van_dropdown_menu.option
       */
      if (this.model.lat && this.model.lon) {
        if (this.model._international == 0) {
          this.van_dropdown_menu = {
            option: [
              { text: '推荐排序', value: 12 },
              { text: '低价优先', value: 31 },
              { text: '高价优先', value: 32 },
              { text: '距离优先', value: 4 }
            ]
          }
        }
      }
    },
    getNearHotelList (page) {
      const { baiduLat, baiduLon } = this.van_list.list[0]
      this.$api['htQuery/hotelList']({
        singaZhid: this.model.singaZhid,
        platZhid: this.model.platZhid,
        checkOutDate: this.model.checkOutDate,
        checkInDate: this.model.checkInDate,
        cityId: this.model.cityId,
        district: this.model.areaId,
        lat: baiduLat,
        lon: baiduLon,
        searchType: 3,
        pageNum: page.num - this.van_list.list.length + 1,
      }).then(res => {
        let arr = res.data ? res.data.list ? res.data.list : [] : [] // 请求的列表数据
        if (arr.length < res.data.count) this.mescrollUp.customHtmlNodata = true
        if (page.num === 1) this.van_list.nearList = [] // 如果是第一页需手动置空列表
        this.van_list.nearList = this.van_list.nearList.concat(arr) // 把请求到的数据添加到列表
        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess(arr.length)
        })
      }).catch(() => {
        this.mescroll.endErr() // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
      })
    },
    selectType () {
      /**
       * 初始化模型中的设施、品牌、主题入参为''
       */
      this.model.brandIds = ''
      this.model.themes = ''
      this.model.propertyIds = ''
      this.model.facilitieNames = ''
      this.model.roomBedType = ''
      this.model.zcfs = ''
      /**
       * 查询入参中的设施、品牌、主题是分开三个入参
       * 品牌：brandIds(多个id逗号隔开)
       * 主题：themes(多个id逗号隔开)
       * 设施：propertyIds(多个id逗号隔开)
       * 设施名称: facilitieNames(多个逗号隔开)
       * 遍历this.van_tree_select_data.items 判断text字符串方式进行分类
       * 将子类中checked:true的子项id取出
       */
      this.van_tree_select_data.items.forEach(element => {
        let checkItems = [],
          checkedNames = []

        element.children.forEach(element_ => {
          if (element_.checked) {
            checkItems.push(element_.id)
            checkedNames.push(element_.conditionName)
          }
          switch (element.text) {
            case '品牌':
              this.model.brandIds = checkItems.join(',')
              break
            case '设施':
              this.model.propertyIds = checkItems.join(',')
              this.model.facilitieNames = checkedNames.join(',')
              break
            case '主题':
              this.model.themes = checkItems.join(',')
              break
            case '房型':
              this.model.roomBedType = checkItems.join(',')
              break
            case '早餐':
              this.model.zcfs = checkItems.join(',')
              break

            default:
              break
          }
        })
      })
      this.$refs['item'].toggle(false)
      if(this.model._international == 0) this.$refs['screen'].toggle(false)
      this.model.starRate = this.model._starRate.join(',')
      this.model.priceRange = this.model._priceRange.join(',')
      /**
       * 重新加载列表
       */
      this.$nextTick(() => {
        this.mescroll.triggerDownScroll()
      })
    },

    showDate(){
      if(this.pageCtrl.isChangeDate){
        let maxDate=''
        if(this.model._max_date){
          maxDate=this.model._max_date
        }else{
          maxDate= formatDate(this.model._min_date,90).date
        }
        this.$refs.date.toggle({
          defaultDate:[this.model._checkInDate.date,this.model._checkOutDate.date],
          minDate:this.model._min_date,
          maxDate:maxDate,
        })
      }
    },
    /**
     * 酒店选择入住/离店日期回调
     * @param {*} data
     */
    getDate (data) {
      [this.model.checkInDate,this.model.checkOutDate] = data;
      [this.model._checkInDate,this.model._checkOutDate] = [formatDate(data[0]),formatDate(data[1])]
      this.model._days = getDiffDays(this.model.checkInDate,this.model.checkOutDate)
      this.mescroll.showDownScroll()
      //重新加载列表
      this.mescroll.triggerDownScroll()
    },

    /**
     * 选择城市回调
     * @param {*} info
     */
    arrdepChange (info) {
      console.log(info)
      this.model._international = info.international == 1 ? 0 : 1
      var cache=''
      if (info.parentName) {
        cache='('+info.parentName+')'
      }
      if (info.areaName) {
        cache='('+info.areaName+')'
      }

      if (this.model._international == 0) {
        this.model._city = info.cityName + cache
        this.model.cityId = info.cityId
        this.model.district = info.areaId
        this.model.areaName = info.areaName
        this.model._cityId = info.cityId
        this.model._cityName = info.cityName
        this.model.sort = 12

        this.$store.dispatch('ht/getTravelPolicy')
      }
      if (this.model._international == 1) {
        this.model._city = info.cityName + cache
        this.model.cityId = info.cityId
        this.model.district = info.areaId
        this.model.areaName = info.areaName
        this.model._cityIdInt = info.cityId
        this.model._cityNameInt = info.cityName
        this.model.sort = 12
        /**
				 * 移除差旅标准
				 */
        this.model._policy = {
          totalClzcJe: '',
          clzcJe: '',
          gkfs: '',
          wjMonths: '',
          clzcBhFwf: '0'
        }
      }

      this.model.lat = ''
      this.model.lon = ''
      this.model._province = ''
      this.model._district = ''
      this.model._street = ''
      this.model.searchType = 0
      this.model.keywords = ''
      this.model._keywords = ''
      this.model.businessZone = ''
      this.model.businessZoneName = ''
      // this.model.district = ''
      this.model.districtName = ''



      this.mescroll.showDownScroll()
      /**
       * 重新加载列表
       */
      this.mescroll.triggerDownScroll()
    },
    /**
     * 重置van_tree_select_data.items
     */
    resetItems () {
      this.van_tree_select_data.items.forEach(element => {
        element.children.forEach(element_ => {
          element_.checked = false
        })
      })
    },
    checkedStarItem (item) {
      item.checked = !item.checked
      this.model._starRate.indexOf(item.id) == '-1' ? this.model._starRate.push(item.id) : this.model._starRate.splice(this.model._starRate.indexOf(item.id), 1)
    },
    checkedPriceItem (item) {
      this.priceItems.staticDataBeanList.forEach(element => {
        if (item.id != element.id) element.checked = false
      })
      item.checked = !item.checked
      item.checked ? this.model._priceRange = [item.id] : this.model._priceRange = []
    },
    /**
     * 重置星级
     */
    resetStarItems () {
      this.model._starRate = []
      this.starItems.staticDataBeanList.forEach(element => {
        element.checked = false
      })
      this.model._priceRange = []
      this.priceItems.staticDataBeanList.forEach(element => {
        element.checked = false
      })
    },
    // 返回上一级
    back() {
      if (localStorage.getItem('home')) {
        this.$router.go(-1);
        return
      }
      this.$router.push({path: this.model.backPath})
    }
  },
}
</script>

<style lang="less" scoped>
@import '~Assets/styles/currency/ht.less';

.htlist{
  height: calc(100vh - 88px);
//   calc(100vh - 88px); 88vh
  overflow: hidden;
}
.htlistBTLH{
  height:84vh;
//   calc(100vh - 88px); 88vh
  overflow: hidden;
}

.container{
  padding-bottom: 50px;
}

.ht-list-header-filter {
  width: 100%;
  background: #fff;
  z-index: 9;

  .ht-list-header {
    position: relative;
    height: 44px;
    display: flex;
    padding: 6px 10px;
    background: #fff;
    z-index: 3;

    .back-wrapper {
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      font-size: 24px;
      color: #181818;
      padding-right: 10px;
    }

    .date-time {
      background: #f7f7f7;
      border-radius: 2px;
      margin-right: 4px;
      padding: 2px 2px 4px;
      .city {
        margin-top: 3px;
      }
      .checkinout {
        display: flex;
        font-size: 12px;
        line-height: 14px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        letter-spacing: .05px;
        white-space: nowrap;
      }
      span {
        &:last-child {
          padding-left: 4px;
        }
      }
    }

    .citysug {
      display: flex;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding: 6px 0;
      background: #f7f7f7;
      border-radius: 2px;
      overflow: hidden;
      .date-time-line {
        position: relative;
        padding: 0 8px;
        &::before {
          content: "";
          position: absolute;
          border-right: .5px solid #e6e6e6;
          height: 20px;
          right: 0;
          width: 1px;
          top: 50%;
          margin-top: -10px;
        }
      }

      .city {
        font-size: 12px;
        border-right: .5px solid #e6e6e6;
        min-width: 60px;
        padding: 0 8px;
        line-height: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .sug {
        color: #9e9e9e;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        padding: 0 8px;
        font-size: 12px;
        line-height: 12px;
        i {
          vertical-align: middle;
          color: #181818;
        }
        span {
          width: 100px;
          display: block;
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }

    .icon-map-box {
      min-width: 22px;
      margin-left: 5px;
      text-align: center;
      color: #181818;
      padding-right: 5px;
      font-size: 12px;

      .icon-map {
        font-size: 16px;
        vertical-align: middle;
        padding: 2px;
        color: #181818;
      }

      &:active {
        opacity: 0.6;
      }
    }
  }
}


.other-dropdown-btn {
  margin-left: 20px;
  line-height: 38px;
  > span {
    padding: 4px 8px;
  }
}

.drop-box {
  padding: 10px 16px;
  h3 {
    font-size: 14px;
    color: #181818;
    > span {
      font-size: 12px;
      font-weight: normal;
      color: #999;
    }
  }
  ul {
    padding: 10px 0;
    li {
      padding: 5px 10px;
    }
    li.active {
      border: 1px solid @color-background-main;
      color: @color-background-main;
    }
    li.item-2 {
      width: 50%;
      float: left;
      a {
        display: block;
        text-align: center;
        border: 1px solid #ccc;
        color: @color-text-deepGray;
        font-size: 12px;
        border-radius: 2px;
        padding: 0 5px;
        height: 32px;
        line-height: 32px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      a.active {
        border: 1px solid;
      }
    }
    li.item-3 {
      width: 33.33333333333%;
      float: left;
      a {
        display: block;
        text-align: center;
        border: 1px solid #ccc;
        color: @color-text-deepGray;
        font-size: 12px;
        border-radius: 2px;
        padding: 0 5px;
        height: 28px;
        line-height: 28px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      a.active {
        border: 1px solid;
      }
    }
  }
}

.drop-btns {
  display: flex;
  background: #eeeeef;
  padding: 10px;
  > a {
    font-size: 12px;
    text-align: center;
    padding: 8px 10px;
    border-radius: 2px;
    &:active {
      background: rgba(0,0,0,.1);
    }
  }
  .reset {
    background: #fff;
    color: #999;
    width: 100px;
  }
  .selection {
    flex: 1;
    overflow: hidden;
    color: #fff;
    margin-left: 10px;
  }
}

.htlist-map {
  position: relative;

  .top-toast {
    position: absolute;
    top: 35px;
    left: 50%;
    font-size: 12px;
    line-height: inherit;
    color: #fff;
    background: rgba(0, 0, 0, .6);
    border-radius: 24px;
    padding: 10px 17px;
    transform: translate3d(-50%, -50%, 0);
  }

  .map-list {
    position: fixed;
    bottom: 12px;
    left: 12px;
    width: calc(100% - 24px);
    border-radius: @border-radius-sm;
    overflow: hidden;
  }
}

/* van-tree-select 重置 */
.deep-dropdown-item /deep/ .van-dropdown-menu__bar {
  height: 40px;
  box-shadow: none;
}
.van-tree-select__nav {
  flex: none !important;
  width: 65px !important;
  text-align: center !important;
}
.van-tree-select__nav-item {
  padding: 12px 8px 12px 8px;
}
.mt2 {
  margin-top: 2px;
}
.h40 {
  height: 40px;
}
.current {
  width: 100%;
  height: 32px;
  line-height: 32px;
  background: #f7f7f7;
  color: #777f8e;
  padding: 0 12px;
}
</style>
